(function () {
  const DATA_ID = "ss-fit-finder-data";
  const ROOT_SELECTOR = "[data-ss-fit-finder-root]";
  const OPEN_SELECTOR = "[data-fit-finder-open]";
  const STATE_KEY = "ss_fit_finder_state_v1";
  const CONTACT_EMAIL = "info@seymoursolar.com";
  let lastFocusedElement = null;

  function dlPush(eventName, payload) {
    const saved = storedFinderState();
    const evt = {
      event: eventName,
      fit_session_id: saved.fit_session_id || null,
      fit_case_id: saved.fit_case_id || null,
      ...payload,
    };
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(evt);
    } catch (e) {}
    try {
      console.log("[FitFinder]", evt);
    } catch (e) {}
    try {
      if (window.SeymourFitFinderBackup) {
        window.SeymourFitFinderBackup.send(eventName, evt);
      }
    } catch (e) {}
  }

  function getEntryPoint() {
    try {
      if (
        window.location.pathname === "/" ||
        document.documentElement.classList.contains("template-index")
      )
        return "homepage";
      if (window.location.pathname.indexOf("/pages/help-choosing") === 0)
        return "help_choosing";
      if (window.location.pathname.indexOf("/pages/sizing-guide") === 0)
        return "sizing_guide";
      if (window.location.pathname.indexOf("/collections/telescope-solar-filters") === 0)
        return "telescope_collection";
      if (window.location.pathname.indexOf("/products/") === 0)
        return "product_page";
      return "unknown";
    } catch (e) {
      return "unknown";
    }
  }

  function parseData() {
    const el = document.getElementById(DATA_ID);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || "{}");
    } catch (e) {
      return null;
    }
  }

  function inchesToMm(inches) {
    return inches * 25.4;
  }

  function normalizeToMm(value, unit) {
    return unit === "in" ? inchesToMm(value) : value;
  }

  function validNumber(x) {
    return typeof x === "number" && isFinite(x);
  }

  function storedFinderState() {
    try {
      return JSON.parse(window.localStorage.getItem(STATE_KEY) || "null") || {};
    } catch (e) {
      return {};
    }
  }

  function sizingHelpMailto(value, unit, normalizedMm) {
    const saved = storedFinderState();
    const equipment = saved.original_model_query ||
      [saved.manufacturer_input, saved.model_input].filter(Boolean).join(" ");
    const subject = `Sizing help - ${value} ${unit} outside diameter`;
    const body = [
      "I used the Seymour Solar Fit Finder but did not find a standard slip-on filter match.",
      equipment ? `Equipment: ${equipment}` : "",
      `Outside-diameter measurement: ${value} ${unit} (${Math.round(normalizedMm * 100) / 100} mm)`,
      saved.fit_case_id ? `Fit Finder case: ${saved.fit_case_id}` : "",
      saved.fit_session_id ? `Fit Finder session: ${saved.fit_session_id}` : "",
      "Please help me confirm the correct filter size or available options.",
    ].filter(Boolean).join("\n\n");
    return `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  // Locked rule: min ≤ OD ≤ max
  function findMatch(sizeVariants, userMm) {
    const variants = sizeVariants
      .filter((variant) => validNumber(variant.min_mm) && validNumber(variant.max_mm))
      .slice()
      .sort((a, b) => Number(a.min_mm) - Number(b.min_mm));
    if (!variants.length) return null;

    const smallest = variants[0];
    const largest = variants[variants.length - 1];
    if (userMm < Number(smallest.min_mm) || userMm > Number(largest.max_mm)) return null;

    return variants.find((variant) => {
      return Number(variant.min_mm) <= userMm && userMm <= Number(variant.max_mm);
    }) || variants.find((variant) => userMm < Number(variant.min_mm)) || null;
  }

  /**
   * More forgiving bundle classifier.
   * Common real-world values seen in Shopify JSON/metafields:
   * - "pair", "pairs", "binocular pair", "binoculars", "set of 2"
   * - "single", "one", "telescope", "camera"
   */
  function classifyBundle(bundleType) {
    const bt = (bundleType || "").toString().trim().toLowerCase();
    if (!bt) return "unknown";

    // Treat anything containing "pair"/"set of 2"/"two" as pair
    if (/\bpair(s)?\b/.test(bt)) return "pair";
    if (/\bset\b/.test(bt) && (/\b2\b/.test(bt) || /\btwo\b/.test(bt)))
      return "pair";
    if (
      /\bbinocular/.test(bt) &&
      (/\b2\b/.test(bt) || /\btwo\b/.test(bt) || /\bpair\b/.test(bt) || /\bpairs\b/.test(bt))
    )
      return "pair";

    if (/\bsingle\b|\bone\b|\b1\b/.test(bt)) return "single";

    // If it mentions binoculars but not explicitly "pair", still assume pair
    if (/\bbinocular/.test(bt)) return "pair";

    return "unknown";
  }

  // Extract a stable "size key" from a variant title
  // Prefers mm in parentheses like "(90mm)".
  function extractSizeKey(title) {
    const t = (title || "").toString();

    // Match "(90mm)" or "(90 mm)"
    const mmMatch = t.match(/\((\d+(?:\.\d+)?)\s*mm\)/i);
    if (mmMatch && mmMatch[1]) return `mm:${mmMatch[1]}`;

    // Fallback: any "90mm" anywhere
    const mmAny = t.match(/(?:^|\s)(\d+(?:\.\d+)?)\s*mm(?:\s|$)/i);
    if (mmAny && mmAny[1]) return `mm:${mmAny[1]}`;

    // Fallback: leading inches like `3.5"` or `3.5”`
    const inMatch = t.match(/^\s*(\d+(?:\.\d+)?)\s*["”]/);
    if (inMatch && inMatch[1]) return `in:${inMatch[1]}`;

    // Fallback: any inches like 5" anywhere
    const inAny = t.match(/(?:^|\s)(\d+(?:\.\d+)?)\s*["”](?:\s|$)/);
    if (inAny && inAny[1]) return `in:${inAny[1]}`;

    // Last resort: normalized title
    return `t:${t.toLowerCase().replace(/\s+/g, " ").trim()}`;
  }

  // Pull numeric hints (mm / in) from the matched size title
  function extractNumericHints(matchedVariantTitle) {
    const t = (matchedVariantTitle || "").toString();
    const mm =
      (t.match(/\((\d+(?:\.\d+)?)\s*mm\)/i) || [])[1] ||
      (t.match(/(?:^|\s)(\d+(?:\.\d+)?)\s*mm(?:\s|$)/i) || [])[1] ||
      null;

    const inch =
      (t.match(/^\s*(\d+(?:\.\d+)?)\s*["”]/) || [])[1] ||
      (t.match(/(?:^|\s)(\d+(?:\.\d+)?)\s*["”](?:\s|$)/) || [])[1] ||
      null;

    return {
      mm: mm ? Number(mm) : null,
      in: inch ? Number(inch) : null,
    };
  }

  function findVariantIdForProduct(product, matchedVariantTitle) {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    if (!variants.length) return null;

    const matchedKey = extractSizeKey(matchedVariantTitle);
    const hints = extractNumericHints(matchedVariantTitle);

    // 1) size key match
    for (const v of variants) {
      if (!v || !v.title || !v.id) continue;
      if (extractSizeKey(v.title) === matchedKey) return v.id;
    }

    // 2) numeric hint match (mm)
    if (validNumber(hints.mm)) {
      const mmStr = String(hints.mm);
      for (const v of variants) {
        if (!v || !v.title || !v.id) continue;
        const vt = v.title.toString();
        if (new RegExp(`\\b${mmStr}\\s*mm\\b`, "i").test(vt)) return v.id;
        if (new RegExp(`\\(${mmStr}\\s*mm\\)`, "i").test(vt)) return v.id;
      }
    }

    // 3) numeric hint match (inches) with tolerance for formatting (5" vs 5.0)
    if (validNumber(hints.in)) {
      const inStr = String(hints.in);
      for (const v of variants) {
        if (!v || !v.title || !v.id) continue;
        const vt = v.title.toString();
        if (new RegExp(`\\b${inStr}\\s*["”]\\b`).test(vt)) return v.id;
        if (new RegExp(`^\\s*${inStr}\\s*["”]`).test(vt)) return v.id;
      }
      // Also try rounded (e.g., 5.0 vs 5)
      const inRounded = String(Math.round(hints.in));
      if (inRounded !== inStr) {
        for (const v of variants) {
          if (!v || !v.title || !v.id) continue;
          const vt = v.title.toString();
          if (new RegExp(`\\b${inRounded}\\s*["”]\\b`).test(vt)) return v.id;
          if (new RegExp(`^\\s*${inRounded}\\s*["”]`).test(vt)) return v.id;
        }
      }
    }

    // 4) exact title match
    for (const v of variants) {
      if (!v || !v.title || !v.id) continue;
      if (v.title === matchedVariantTitle) return v.id;
    }

    return null;
  }

  function buildResults(data, deviceSelected) {
    const results = [];

    if (data.canonical) results.push(data.canonical);
    const equiv = Array.isArray(data.equivalents) ? data.equivalents : [];
    results.push(...equiv);

    // Dedup by handle
    const dedup = [];
    const seen = new Set();
    for (const p of results) {
      if (!p || !p.handle) continue;
      if (seen.has(p.handle)) continue;
      seen.add(p.handle);
      dedup.push(p);
    }

    // deviceSelected: "single_device" | "binoculars" | "any"
    if (deviceSelected === "binoculars") {
      const onlyPairs = dedup.filter((p) => classifyBundle(p.bundle_type) === "pair");
      return { list: onlyPairs, fellBack: onlyPairs.length === 0 };
    }
    if (deviceSelected === "single_device") {
      const nonPairs = dedup.filter((p) => classifyBundle(p.bundle_type) !== "pair");
      return { list: nonPairs, fellBack: nonPairs.length === 0 };
    }
    return { list: dedup, fellBack: false }; // any
  }

  function ensureModal() {
    // reuse existing modal if init runs more than once
    const existing = document.getElementById("ss-fit-finder-modal");
    if (existing) {
      return {
        modal: existing,
        panel: document.getElementById("ss-fit-finder-panel"),
        close: function () {
          existing.style.display = "none";
          document.body.style.overflow = "";
        },
      };
    }

    // inject CSS once (beats theme overrides)
    const style = document.createElement("style");
    style.textContent = `
      #ss-fit-finder-panel [data-ff-device]{
        padding:10px 12px !important;
        border:1px solid rgba(0,0,0,.18) !important;
        border-radius:10px !important;
        background:#fff !important;
        color:#000 !important;
        cursor:pointer !important;
      }
      #ss-fit-finder-panel [data-ff-device="any"]{
        border-style:dashed !important;
      }
      #ss-fit-finder-panel [data-ff-device][data-selected="true"]{
        background:#111 !important;
        color:#fff !important;
        border-color:#111 !important;
      }
      #ss-fit-finder-panel [data-ff-note]{
        font-size:12px;
        opacity:.8;
        margin:10px 0 0;
        padding:10px 12px;
        border:1px solid rgba(0,0,0,.10);
        border-radius:12px;
        background:rgba(0,0,0,.03);
      }
      #ss-fit-finder-panel [data-ff-measure-wrap]{
        margin:10px 0 14px;
        font-size:12px;
        opacity:.85;
      }
      #ss-fit-finder-panel [data-ff-measure]{
        text-decoration: underline;
        color: inherit;
      }
    `;
    document.head.appendChild(style);

    const modal = document.createElement("div");
    modal.id = "ss-fit-finder-modal";
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.setAttribute("aria-labelledby", "ss-fit-finder-title");
    modal.setAttribute("aria-describedby", "ss-fit-finder-description");
    modal.style.cssText = `
      position: fixed; inset: 0; z-index: 999999;
      display: none; align-items: center; justify-content: center;
      background: rgba(0,0,0,.55); padding: 16px;
    `;

    const panel = document.createElement("div");
    panel.id = "ss-fit-finder-panel";
    panel.style.cssText = `
      width: 100%; max-width: 760px; background: #fff; border-radius: 16px;
      box-shadow: 0 10px 30px rgba(0,0,0,.25);
      max-height: 90vh; overflow-y: auto; font-family: inherit;
    `;

    panel.innerHTML = `
      <div style="display:flex; justify-content:space-between; align-items:center; padding:16px; border-bottom:1px solid rgba(0,0,0,.08);">
        <div>
          <h2 id="ss-fit-finder-title" style="font-weight:700; font-size:18px; line-height:1.2; margin:0;">Find Your Slip-On Filter Size</h2>
          <p id="ss-fit-finder-description" style="font-size:13px; opacity:.75; margin:4px 0 0;">Search by telescope make or model, or enter your equipment’s outside diameter (OD).</p>
        </div>
        <button type="button" data-ff-close style="appearance:none; border:0; background:transparent; font-size:22px; line-height:1; padding:8px; cursor:pointer;" aria-label="Close">×</button>
      </div>

      <div style="padding:16px;">
        <div style="margin-bottom:16px;">
          <div style="font-weight:600; margin-bottom:8px;">Optional: What are you using this on?</div>
          <div style="display:flex; flex-wrap:wrap; gap:8px;">
            <button type="button" data-ff-device="single_device" data-selected="false" aria-pressed="false">Telescope / Camera / Spotting scope</button>
            <button type="button" data-ff-device="binoculars" data-selected="false" aria-pressed="false">Binoculars</button>
            <button type="button" data-ff-device="any" data-selected="true" aria-pressed="true">Skip</button>
          </div>
          <div style="font-size:12px; opacity:.75; margin-top:8px;">Skipping will show both single and pair options.</div>
          <div data-ff-note style="display:none;"></div>
        </div>

        <div style="margin-bottom:12px;">
          <label for="ss-fit-finder-od" style="display:block; font-weight:600; margin-bottom:8px;">Outside diameter (OD)</label>
          <div style="display:flex; gap:8px; align-items:center;">
            <input id="ss-fit-finder-od" inputmode="decimal" type="text" data-ff-od value="" placeholder="e.g., 122.5" aria-describedby="ss-fit-finder-input-error"
              style="flex:1; padding:12px; border:1px solid rgba(0,0,0,.18); border-radius:10px;" />
            <label for="ss-fit-finder-unit" style="position:absolute; width:1px; height:1px; padding:0; margin:-1px; overflow:hidden; clip:rect(0,0,0,0); white-space:nowrap; border:0;">Measurement unit</label>
            <select id="ss-fit-finder-unit" data-ff-unit style="padding:12px; border:1px solid rgba(0,0,0,.18); border-radius:10px; background:#fff;">
              <option value="mm">mm</option>
              <option value="in">in</option>
            </select>
            <button type="button" data-ff-submit style="padding:12px 14px; border:0; border-radius:10px; background:#111; color:#fff; cursor:pointer;">Find my size</button>
          </div>
          <div id="ss-fit-finder-input-error" data-ff-input-error role="alert" style="display:none; color:#8a2418; font-size:13px; margin-top:8px;">Enter a valid outside-diameter measurement.</div>
        </div>

        <!-- Measurement off-ramp (opens in new tab) -->
        <div data-ff-measure-wrap>
          Don’t have your measurement?
          <a
            data-ff-measure
            href="/pages/sizing-guide"
            target="_blank"
            rel="noopener"
          >Learn how to measure</a>
        </div>

        <div data-ff-step="results" style="display:none;">
          <div data-ff-summary style="margin-bottom:12px;"></div>
          <div data-ff-results style="display:grid; grid-template-columns:1fr; gap:10px;"></div>
        </div>

        <div data-ff-step="nomatch" style="display:none; padding:12px; border:1px solid rgba(0,0,0,.12); border-radius:12px; background:rgba(0,0,0,.03);">
          <div style="font-weight:700; margin-bottom:6px;">We don’t have a slip-on filter that fits this size.</div>
          <div style="font-size:13px; opacity:.85; margin-bottom:10px;">Email us with the measurement you entered and any equipment information already provided.</div>
          <a data-ff-support href="mailto:info@seymoursolar.com" style="display:inline-block; padding:10px 12px; border-radius:10px; background:#111; color:#fff; text-decoration:none;">Email us for sizing help</a>
        </div>
      </div>
    `;

    modal.appendChild(panel);
    document.body.appendChild(modal);

    function close() {
      modal.style.display = "none";
      document.body.style.overflow = "";
      if (lastFocusedElement && document.contains(lastFocusedElement)) {
        lastFocusedElement.focus();
      }
    }

    modal.addEventListener("click", (e) => {
      if (e.target === modal) close();
    });
    panel.querySelector("[data-ff-close]").addEventListener("click", close);

    document.addEventListener("keydown", (e) => {
      if (modal.style.display === "none") return;
      if (e.key === "Escape") {
        e.preventDefault();
        close();
        return;
      }
      if (e.key !== "Tab") return;
      const focusable = Array.from(panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter((element) => element.getClientRects().length > 0);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
        e.preventDefault();
        first.focus();
      }
    });

    return { modal, panel, close };
  }

  function init() {
    const data = parseData();
    const root = document.querySelector(ROOT_SELECTOR);
    if (!data || !root) return;
    if (root.dataset.fitFinderCoreInitialized === "true") return;
    root.dataset.fitFinderCoreInitialized = "true";

    const entryPoint = getEntryPoint();
    const { modal, panel } = ensureModal();

    const els = {
      od: panel.querySelector("[data-ff-od]"),
      unit: panel.querySelector("[data-ff-unit]"),
      submit: panel.querySelector("[data-ff-submit]"),
      resultsWrap: panel.querySelector('[data-ff-step="results"]'),
      results: panel.querySelector("[data-ff-results]"),
      summary: panel.querySelector("[data-ff-summary]"),
      noMatch: panel.querySelector('[data-ff-step="nomatch"]'),
      support: panel.querySelector("[data-ff-support]"),
      deviceBtns: Array.from(panel.querySelectorAll("[data-ff-device]")),
      note: panel.querySelector("[data-ff-note]"),
      measureLink: panel.querySelector("[data-ff-measure]"),
      measureWrap: panel.querySelector("[data-ff-measure-wrap]"),
      inputError: panel.querySelector("[data-ff-input-error]"),
    };

    let deviceSelected = "any"; // default = skip

    function setDeviceSelection(val) {
      deviceSelected = val;

      els.deviceBtns.forEach((btn) => {
        const isSelected = btn.getAttribute("data-ff-device") === val;
        btn.setAttribute("data-selected", isSelected ? "true" : "false");
        btn.setAttribute("aria-pressed", isSelected ? "true" : "false");
      });

      // Clear any note when toggling
      els.note.style.display = "none";
      els.note.textContent = "";

      dlPush("fit_finder_device_selected", {
        entry_point: entryPoint,
        device_selected: deviceSelected,
      });
    }

    els.deviceBtns.forEach((btn) => {
      btn.addEventListener("click", () =>
        setDeviceSelection(btn.getAttribute("data-ff-device"))
      );
    });

    function open(trigger) {
      lastFocusedElement = trigger || document.activeElement;
      if (window.SeymourFitFinderBackup && typeof window.SeymourFitFinderBackup.startCase === "function") {
        window.SeymourFitFinderBackup.startCase({ entry_point: entryPoint });
      }
      modal.style.display = "flex";
      document.body.style.overflow = "hidden";

      els.resultsWrap.style.display = "none";
      els.noMatch.style.display = "none";
      els.results.innerHTML = "";
      els.summary.innerHTML = "";
      els.inputError.style.display = "none";
      els.od.removeAttribute("aria-invalid");

      dlPush("fit_finder_opened", { entry_point: entryPoint });

      // reset device selection to skip each open
      setDeviceSelection("any");
      window.setTimeout(() => {
        const firstField = panel.querySelector('[data-ff-model-search] input, [data-ff-od]');
        if (firstField) firstField.focus();
      }, 0);
    }

    // delegated open binding
    document.addEventListener("click", (e) => {
      const t = e.target.closest(OPEN_SELECTOR);
      if (!t) return;
      e.preventDefault();
      e.stopPropagation();
      open(t);
    });

    if (els.measureLink) {
      if (window.location.pathname.indexOf("/pages/sizing-guide") === 0 && els.measureWrap) {
        els.measureWrap.style.display = "none";
      }
      els.measureLink.addEventListener("click", () => {
        dlPush("fit_finder_measure_help_clicked", {
          entry_point: entryPoint,
          device_selected: deviceSelected,
        });
      });
    }

    els.support.addEventListener("click", () => {
      dlPush("fit_finder_result_clicked", {
        entry_point: entryPoint,
        result_type: "support_cta",
        device_selected: deviceSelected,
      });
    });

    els.submit.addEventListener("click", () => {
      const raw = (els.od.value || "").trim().replace(",", ".");
      const num = Number(raw);
      const unit = els.unit.value;
      if (!validNumber(num) || num <= 0) {
        els.inputError.style.display = "block";
        els.od.setAttribute("aria-invalid", "true");
        return;
      }
      els.inputError.style.display = "none";
      els.od.removeAttribute("aria-invalid");

      const mm = normalizeToMm(num, unit);

      dlPush("fit_finder_od_submitted", {
        entry_point: entryPoint,
        device_selected: deviceSelected,
        od_input_value: num,
        od_input_unit: unit,
        od_normalized_mm: mm,
      });

      const match = findMatch(data.size_variants || [], mm);

      if (!match) {
        els.resultsWrap.style.display = "none";
        els.noMatch.style.display = "block";
        els.support.href = sizingHelpMailto(num, unit, mm);
        dlPush("fit_finder_no_match", {
          entry_point: entryPoint,
          device_selected: deviceSelected,
          od_input_value: num,
          od_input_unit: unit,
          od_normalized_mm: mm,
          outcome: "no_size_match",
        });
        return;
      }

      const built = buildResults(data, deviceSelected);
      let results = built.list;

      // If user chose binoculars but none were detected as "pair",
      // show a note and fall back to "any"
      if (deviceSelected === "binoculars" && built.fellBack) {
        const fallback = buildResults(data, "any");
        results = fallback.list;

        els.note.textContent =
          "No products were marked as “Pair” for binoculars in the fit-finder data, so showing all options instead. (Fix by setting bundle_type for binocular products to “pair”.)";
        els.note.style.display = "block";

        dlPush("fit_finder_results_fallback", {
          entry_point: entryPoint,
          device_selected: deviceSelected,
          fallback_to: "any",
          reason: "no_pair_products_detected",
        });
      }

      els.noMatch.style.display = "none";
      els.resultsWrap.style.display = "block";
      els.results.innerHTML = "";

      els.summary.innerHTML = `
        <div style="font-weight:700; margin-bottom:6px;">Your size:</div>
        <div style="font-size:14px; opacity:.9;">
          <div><strong>${match.title}</strong></div>
          <div style="margin-top:4px;">Fits OD ${match.min_mm}–${match.max_mm} mm</div>
        </div>
      `;

      dlPush("fit_finder_match_found", {
        entry_point: entryPoint,
        device_selected: deviceSelected,
        od_normalized_mm: mm,
        od_input_value: num,
        od_input_unit: unit,
        matched_variant_title: match.title,
        matched_min_mm: match.min_mm,
        matched_max_mm: match.max_mm,
        results_shown_count: results.length,
      });

      for (const p of results) {
        const variantId = findVariantIdForProduct(p, match.title);
        const href = variantId ? `${p.url}?variant=${variantId}` : p.url;

        const bundle = classifyBundle(p.bundle_type);
        const material = (p.material_type || "").toString();
        const key = (p.fit_finder_key || "").toString();

        const card = document.createElement("div");
        card.style.cssText = `
          padding:12px; border:1px solid rgba(0,0,0,.12); border-radius:12px;
          display:flex; justify-content:space-between; gap:12px; align-items:center;
        `;

        const left = document.createElement("div");
        left.innerHTML = `
          <div style="font-weight:700; margin-bottom:4px;">${p.title}</div>
          <div style="font-size:12px; opacity:.75;">
            ${material ? material : ""}${
          material && bundle !== "unknown" ? " • " : ""
        }${
          bundle !== "unknown" ? (bundle === "pair" ? "Pair" : "Single") : ""
        }
          </div>
          <div style="font-size:12px; opacity:.75; margin-top:6px;">Size: ${
            match.title
          }</div>
        `;

        const right = document.createElement("div");
        const a = document.createElement("a");
        a.href = href;
        a.setAttribute("data-ff-product-option", "");
        a.textContent = "View this option";
        a.style.cssText = `display:inline-block; padding:10px 12px; border-radius:10px; background:#111; color:#fff; text-decoration:none; white-space:nowrap;`;

        a.addEventListener("click", () => {
          dlPush("fit_finder_result_clicked", {
            entry_point: entryPoint,
            device_selected: deviceSelected,
            matched_variant_title: match.title,
            product_handle: p.handle,
            variant_id: variantId || null,
            bundle_type: p.bundle_type || "",
            material_type: p.material_type || "",
            fit_finder_key: key,
          });
        });

        right.appendChild(a);
        card.appendChild(left);
        card.appendChild(right);
        els.results.appendChild(card);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
